// extracted by mini-css-extract-plugin
module.exports = {"blue":"#4c98b1","blueLight":"#e9f9ff","orange":"#f38620","grey":"#7d7d7d","greyLight":"#f3f3f3"};